import { defineMessages } from 'react-intl-next';

export const messages: {
	pageTitle: {
		defaultMessage: string;
		id: string;
	};
	whiteboardTitle: {
		defaultMessage: string;
		id: string;
	};
} = defineMessages({
	pageTitle: {
		id: 'confluence.page.preview.panel.pageTitle',
		defaultMessage: 'Confluence Page',
	},
	whiteboardTitle: {
		id: 'confluence.page.preview.panel.whiteboardTitle',
		defaultMessage: 'Confluence Whiteboard',
	},
});
